import React from 'react';
import { railsInputName } from 'members/helpers';
import Glyph from 'components/glyph';

class LogAccessSummary extends React.Component {
  render() {
    if (!this.props.isVisible) { return (null); }

    if (this.props.isEditable) {
      return (
        <EditableLogAccessSummary
          memberId={this.props.memberId}
          manageMembers={this.props.manageMembers}
          readOnly={this.props.readOnly}
          canAccessAllGroups={this.props.canAccessAllGroups}
          purgeLogs={this.props.purgeLogs}
          accessLevel={this.props.accessLevel}
          groupAccessLevel={this.props.groupAccessLevel}
          purgeLogsAccess={this.props.purgeLogsAccess}
          onCheckboxChange={this.props.onCheckboxChange}
          onBoolSelectChange={this.props.onBoolSelectChange}
          onLogAccessSelectChange={this.props.onLogAccessSelectChange}
        />
      );
    } else {
      return (
        <ReadOnlyLogAccessSummary
          readOnly={this.props.readOnly}
          canAccessAllGroups={this.props.canAccessAllGroups}
          purgeLogs={this.props.purgeLogs}
          accessLevel={this.props.accessLevel}
          groupAccessLevel={this.props.groupAccessLevel}
          purgeLogsAccess={this.props.purgeLogsAccess}
        />
      );
    }
  }
}



// *********************************************************************************
// Functional components
// *********************************************************************************



// the section of permissions that summarizes overall log access
// *********************************************************************************
function EditableLogAccessSummary(props) {
  return (
    <div className="permissions-wrapper">
      <div className="log-access">
        <h4>Log Access Permissions</h4>
        <p>
          <select name={railsInputName(props.memberId, 'read_only')}
            disabled={props.manageMembers}
            defaultValue={props.readOnly ? '1' : '0'}
            onChange={props.onLogAccessSelectChange}
          >
            <option value="0">Full</option>
            <option value="1">Read-Only</option>
          </select>
          access to
          <select name={railsInputName(props.memberId, 'can_access_all_groups')}
            disabled={props.manageMembers}
            defaultValue={props.canAccessAllGroups ? '1' : '0'}
            onChange={props.onBoolSelectChange('canAccessAllGroups')}
          >
            <option value="1">All</option>
            <option value="0">Specific</option>
          </select> groups
        </p>

        {
          !props.readOnly && (props.manageMembers || props.canAccessAllGroups) &&
            <p className="full-access-options">
              <Glyph name="right-4" />
              <label>
                <input type="checkbox" value="1"
                  name={railsInputName(props.memberId, 'purge_logs')}
                  defaultChecked={props.purgeLogs}
                  disabled={props.manageMembers}
                  onChange={props.onCheckboxChange('purgeLogs')}
                /> can also purge logs
              </label>
            </p>
        }
      </div>
    </div>
  );
}

// the section of permissions that summarizes overall log access
// *********************************************************************************
function ReadOnlyLogAccessSummary(props) {
  return (
    <div className="permissions-wrapper">
      <div className="log-access">
        <h4>Log Access Permissions</h4>
        <p>
          <strong>{props.accessLevel(props.readOnly)}</strong> access to <strong>{props.groupAccessLevel(props.canAccessAllGroups)}</strong>
          {' '}
          groups and <strong>{props.purgeLogsAccess(props.purgeLogs)}</strong> purge logs
        </p>
      </div>
    </div>
  );
}

export default LogAccessSummary;
